import AdyenCheckout from '@adyen/adyen-web';
import { CoreOptions } from '@adyen/adyen-web/dist/types/core/types';

export function adyenCheckout({ configuration } : { configuration: CoreOptions }): AdyenCheckout {
  return new AdyenCheckout(configuration);
}
